import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { apiRequest, getApiUrl } from '../../config/api';
import SuccessToast from '../SuccessToast';

function LegalDocumentsAdmin() {
  const [documentos, setDocumentos] = useState([]);
  const [elegido, setElegido] = useState(null);
  const [texto, setTexto] = useState('');
  const [error, setError] = useState('');
  const [toast, setToast] = useState(null);

  useEffect(() => {
    apiRequest(getApiUrl('/admin/legal/documents'))
      .then((res) => (res.ok ? res.json() : []))
      .then(setDocumentos)
      .catch(() => setDocumentos([]));
  }, []);

  const abrir = (documento) => {
    setElegido(documento);
    setTexto(documento.contentText || '');
    setError('');
  };

  const cerrar = () => {
    setElegido(null);
    setTexto('');
    setError('');
  };

  const guardar = () => {
    if (!elegido) return;
    setError('');
    apiRequest(getApiUrl(`/admin/legal/documents/${elegido.documentType}`), {
      method: 'POST',
      body: JSON.stringify({ contentText: texto }),
    })
      .then(async (res) => {
        const body = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(body.error || 'No se pudo guardar');
        }
        return body;
      })
      .then((publicado) => {
        setDocumentos((prev) => prev.map((doc) => (
          doc.documentType === publicado.documentType ? publicado : doc
        )));
        cerrar();
        setToast('Contrato publicado');
      })
      .catch((fallo) => setError(fallo.message));
  };

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <h2>Contratos</h2>
      </div>
      <ul className="admin-contratos-lista">
        {documentos.map((documento) => (
          <li key={documento.documentType}>
            <span>
              {documento.documentTypeName} · {documento.versionNumber}
            </span>
            <button
              type="button"
              className="admin-btn secondary"
              onClick={() => abrir(documento)}
            >
              Editar
            </button>
          </li>
        ))}
      </ul>
      {elegido && createPortal(
        <div className="modal-overlay" onClick={cerrar}>
          <div
            className="modal-content admin-modal admin-contrato-editor"
            role="dialog"
            aria-modal="true"
            aria-labelledby="contrato-texto-label"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3 id="contrato-texto-label">Texto de {elegido.documentTypeName}</h3>
              <button type="button" className="modal-close" aria-label="Cerrar" onClick={cerrar}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <textarea
                id="contrato-texto"
                aria-labelledby="contrato-texto-label"
                value={texto}
                onChange={(e) => setTexto(e.target.value)}
              />
              <p className="admin-contrato-ayuda">
                Los huecos como {'{{NOMBRE}}'} o {'{{CIF}}'} se rellenan al firmar.
              </p>
              <div className="modal-actions">
                <button type="button" className="admin-btn secondary" onClick={cerrar}>
                  Cancelar
                </button>
                <button type="button" className="admin-btn primary" onClick={guardar}>
                  Guardar
                </button>
              </div>
              {error && <div className="legal-banner-error">{error}</div>}
            </div>
          </div>
        </div>,
        document.body
      )}
      <SuccessToast message={toast} onDismiss={() => setToast(null)} />
    </div>
  );
}

export default LegalDocumentsAdmin;
